<template>
  <CamoCategoriesPicker v-if="!$isMobile()" />
  <CamoCategoriesMobile v-else-if="$isMobile()" />

  <WeaponPicker v-if="!checkoutStore.getCamoSpecials?.id && !$isMobile()" />
  <MobileWeaponPicker
    v-else-if="!checkoutStore.getCamoSpecials?.id && $isMobile()"
  />
  <ExtraOptionPicker />
  <PlatformPicker />
</template>

<script setup>
import CamoCategoriesPicker from "../pickers/CamoCategoriesPicker.vue";
import CamoCategoriesMobile from "../pickers/CamoCategoriesMobile.vue";
import WeaponPicker from "../pickers/WeaponPicker.vue";
import ExtraOptionPicker from "../pickers/ExtraOptionPicker.vue";
import PlatformPicker from "../../commonpickers/PlatformPicker.vue";
import MobileWeaponPicker from "../pickers/mobile/MobileWeaponPicker.vue";

const gameStore = useGameStore();
const checkoutStore = useCheckoutStore();

const handleDetails = () => {
  checkoutStore.clearCheckout();
  const firstOption = gameStore.getGamePack.pack_options[0] || null;
  if (firstOption) {
    checkoutStore.setCamoCategory(firstOption.id);
  }

  checkoutStore.setPlatform({
    platform: 1,
  });
  checkoutStore.setGameAndPack({
    game: gameStore.getGame.id,
    pack: gameStore.getGamePack.id,
    fullGame: gameStore.getGame,
    fullPack: gameStore.getGamePack,
  });
};

handleDetails();

onNuxtReady(() => {
  checkoutStore.setCalculating();
});
</script>
